import { useEffect, useState } from 'react';
import taskService from '../../../../services/TaskService';
import { mapTaskToRow } from '../../../MyTask/helper/helper';

export default function useFetchTotalTask() {
  const [totalTaskLoading, setTotalTaskLoading] = useState(false);
  const [totalTaskRows, setTotalTaskRows] = useState([]);

  useEffect(() => {
    const fetchTotalTask = async () => {
      try {
        setTotalTaskLoading(true);
        const response = await taskService.getAllTasks(); //total task

        const tasks = response?.data?.data || [];
        setTotalTaskRows(
          tasks.map((task) => ({
            ...mapTaskToRow(task),
            dueDate: task.dueDate || ''
          }))
        );
      } catch (error) {
        // eslint-disable-next-line no-console, no-undef
        console.error('Error fetching assigned tasks:', error);
      } finally {
        setTotalTaskLoading(false);
      }
    };
    fetchTotalTask();
  }, []);

  return { totalTaskRows, setTotalTaskRows, totalTaskLoading };
}
